import React from 'react';
import NotebookLMComponent from '../components/NotebookLM';
import './NotebookLM.css';

function NotebookLM({ user }) {
  return (
    <div className="notebooklm-page">
      <div className="notebooklm-container">
        <h1>📚 NotebookLM Content Generator</h1>
        <p className="page-description">
          Create AI-powered content from Jookbox documentation. Generate training materials,
          sales presentations, quizzes, flashcards, and reports.
        </p>
        <NotebookLMComponent user={user} />
      </div>
    </div>
  );
}

export default NotebookLM;


